import type { IconData } from '@stacksjs/iconify-core'

export const bagSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M14.681 2.191c1.933-.306 5.25-.691 9.717-.691s7.785.385 9.718.691c1.392.22 2.332 1.434 2.332 2.805a7.96 7.96 0 0 1-2.362 5.668l-.105.02a35 35 0 0 1-2.054.33c-1.814.242-4.498.487-7.926.487s-6.113-.245-7.927-.487q-.67-.091-1.18-.175a7.96 7.96 0 0 1-2.546-5.843c0-1.371.94-2.584 2.333-2.805M13.42 13.624l.03.006c.512.099 1.26.228 2.227.357c1.936.259 4.752.514 8.324.514s6.387-.255 8.323-.513a39 39 0 0 0 2.227-.358a22 22 0 0 0 .646-.135c2.633 1.848 4.905 4.268 6.667 6.938c2.529 3.83 4.034 8.21 4.034 12.21c0 5.117-2.465 8.615-6.408 10.804c-3.908 2.17-9.256 3.053-15.092 3.053c-5.835 0-11.184-.883-15.091-3.053c-3.944-2.189-6.409-5.687-6.409-10.804c0-4 1.506-8.38 4.034-12.21c1.723-2.608 3.93-4.979 6.487-6.81\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bagSolid
